import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const InjectMessage = ({ id }) => <FormattedMessage id={id} />;
export default injectIntl(InjectMessage, { forwardRef: false });



// WEBPACK FOOTER //
// ./src/helpers/intlMessage.js